import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Import Swiper React components and required styles
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import "./HighlightServices.css";
import HighlightServicesCard from "../../common_components/highlightServicesCard/HighlightServicesCard";
import BreadcrumbNav from "../../common_components/breadcrumbNav/BreadcrumbNav";

const servicesData = [
  {
    id: 1,
    title: "Featured Profile",
    icon: "/assets/Images/career_solutions/HighlightServices/xpress-resume.svg",
    link: "#",
  },
  {
    id: 2,
    title: "Career Booster",
    icon: "/assets/Images/career_solutions/HighlightServices/boost.svg",
    link: "/career-booster",
  },
  {
    id: 3,
    title: "Profile Highlighter",
    icon: "/assets/Images/career_solutions/HighlightServices/resume-highlighter.svg",
     link: "/career-booster",
  },
  {
    id: 4,
    title: "LinkedIn Makeover",
    icon: "/assets/Images/career_solutions/HighlightServices/linkedin-makeover.svg",
     link: "/career-booster",
  },
  {
    id: 5,
    title: "Resume Builder",
    icon: "/assets/Images/career_solutions/HighlightServices/resume-builder.svg",
     link: "/career-booster",
  },
  {
    id: 6,
    title: "Resume Writing",
    icon: "/assets/Images/career_solutions/HighlightServices/right-resume.svg",
     link: "/career-booster",
  },
];

// Define navigation layout items array dynamically
const breadcrumbPaths = [
  { label: "Home", url: "/" },
  { label: "Services", url: "/career-services" },
];

const HighlightServices = () => {
  return (
    <div className="highlight-services-parent">
      <Container>
        <BreadcrumbNav items={breadcrumbPaths} />

        <Row className="align-items-center justify-content-between g-4">
          {/* Left Text Column */}
          <Col lg={4} md={12} className="text-section">
            <h2 className="main-heading">Highlight</h2>
            <p className="sub-heading">
              Get 10x visibility &amp; leave a lasting impression on recruiters.
            </p>
          </Col>

          {/* Right Cards Column with Swiper */}
          <Col lg={8} md={12}>
            <div className="swiper-container-wrapper">
              <Swiper
                spaceBetween={20}
                slidesPerView={2}
                breakpoints={{
                  // Responsive breakdowns matching your original design structure
                  480: { slidesPerView: 3 },
                  576: { slidesPerView: 4 },
                  768: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                }}
                className="services-swiper"
              >
                {servicesData.map((service) => (
                  <SwiperSlide
                    key={service.id}
                    className="d-flex justify-content-center py-2"
                  >
                    <HighlightServicesCard
                      title={service.title}
                      icon={service.icon}
                      link={service.link}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HighlightServices;
